import { gql } from '@apollo/client'

export const sendCourseSizeReportMutation = gql`
  mutation SendCourseSizeReport ($courseId: String!) {
    sendCourseSizeReport (courseId: $courseId)
  }
`
